export const translations = {
  en: {
    title: "Agri-Zapper Guide",
    subtitle: "Smart Light & Timing Settings for Maximum Pest Control",
    searchPlaceholder: "Search 150+ crops...",
    on: "ON (Sunset)",
    off: "OFF",
    pest: "TARGET INSECT",
    light: "SPECTRUM",
    region: "REGIONS",
    category: "CATEGORY",
    noResults: "No crops found matching your search",
    filterByCategory: "Filter by Category",
    allCategories: "All Categories",
    sorting: "Sort By",
    sortName: "Crop Name (A-Z)",
    sortCategory: "Category",
    information: "Information",
    duration: "Duration",
    lightSpectrum: "Light Spectrum",
    affectedRegions: "Affected Regions",
    // stats: "Statistics",
    totalCrops: "Total Crops",
    categories: "Categories",
    regions: "Regions",
    viewDetails: "View Details",
    quickInfo: "Quick Info",
    cropsCovered: "Crops Covered",
    panIndia: "Pan-India Coverage",
    researchBacked: "Research-Backed Data",
    optimization: "Real-Time Optimization",
    features: "Features",
    multiLanguage: "Multi-Language Support",
    advancedFilter: "Advanced Filtering",
    categoriesSearch: "Category-Based Search",
    expandDetails: "Expandable Details",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    contact: "Contact Us",
    madeWith: "Made with ❤️ for Indian Farmers",
    productsTitle: "CropShield Products",
    productsSubtitle: "Explore our solar-powered crop protection devices and accessories",
    hideDetails: "Hide Details",
    cropSingular: "crop",
    cropPlural: "crops",
    showingPrefix: "Showing",
    inCategory: "in",
    matchingSearch: "matching",
    catNames: {
      FIBRE: "Fibre", FLOWER: "Flower", FRUIT: "Fruit", GRAIN: "Grain", MEDICINAL: "Medicinal",
      OILSEED: "Oilseed", PLANTATION: "Plantation", PULSE: "Pulse", SPICE: "Spice", VEGETABLE: "Vegetable",
    },
  },
  hi: {
    title: "एग्री-जैपर गाइड",
    subtitle: "अधिकतम कीट नियंत्रण के लिए स्मार्ट प्रकाश और समय सेटिंग",
    searchPlaceholder: "150+ फसलें खोजें...",
    on: "चालू (सूर्यास्त)",
    off: "बंद करें",
    pest: "लक्ष्य कीट",
    light: "स्पेक्ट्रम",
    region: "क्षेत्र",
    category: "श्रेणी",
    noResults: "आपकी खोज से मेल खाने वाली कोई फसल नहीं मिली",
    filterByCategory: "श्रेणी के अनुसार फ़िल्टर करें",
    allCategories: "सभी श्रेणियां",
    sorting: "द्वारा सॉर्ट करें",
    sortName: "फसल नाम (A-Z)",
    sortCategory: "श्रेणी",
    information: "जानकारी",
    duration: "अवधि",
    lightSpectrum: "प्रकाश स्पेक्ट्रम",
    affectedRegions: "प्रभावित क्षेत्र",
    stats: "आंकड़े",
    totalCrops: "कुल फसलें",
    categories: "श्रेणियां",
    regions: "क्षेत्र",
    viewDetails: "विवरण देखें",
    quickInfo: "त्वरित जानकारी",
    cropsCovered: "फसलें कवर की गई",
    panIndia: "भारत भर में कवरेज",
    researchBacked: "शोध-समर्थित डेटा",
    optimization: "वास्तविक समय अनुकूलन",
    features: "विशेषताएं",
    multiLanguage: "बहु-भाषा समर्थन",
    advancedFilter: "उन्नत निस्पंदन",
    categoriesSearch: "श्रेणी-आधारित खोज",
    expandDetails: "विस्तार योग्य विवरण",
    privacy: "गोपनीयता नीति",
    terms: "सेवा की शर्तें",
    contact: "संपर्क करें",
    madeWith: "भारतीय किसानों के लिए ❤️ के साथ बनाया गया",
    productsTitle: "CropShield उत्पाद",
    productsSubtitle: "हमारे सौर-संचालित फसल सुरक्षा उपकरण और सहायक उपकरण देखें",
    hideDetails: "विवरण छुपाएं",
    cropSingular: "फसल",
    cropPlural: "फसलें",
    showingPrefix: "दिखा रहे हैं",
    inCategory: "श्रेणी में",
    matchingSearch: "से मेल खाती",
    catNames: {
      FIBRE: "रेशा", FLOWER: "फूल", FRUIT: "फल", GRAIN: "अनाज", MEDICINAL: "औषधीय",
      OILSEED: "तिलहन", PLANTATION: "बागान", PULSE: "दलहन", SPICE: "मसाला", VEGETABLE: "सब्जी",
    },
  },
  gu: {
    title: "એગ્રી-ઝેપર ગાઈડ",
    subtitle: "મહત્તમ જંતુ નિયંત્રણ માટે સ્માર્ટ પ્રકાશ અને સમય સેટિંગ",
    searchPlaceholder: "150+ પાકો શોધો...",
    on: "ચાલુ (સૂર્યાસ્ત)",
    off: "બંધ કરો",
    pest: "લક્ષ્ય જંતુ",
    light: "સ્પેક્ટ્રમ",
    region: "પ્રદેશ",
    category: "શ્રેણી",
    noResults: "તમારી શોધ સાથે મેળતી કોઈ પાક મળી નહીં",
    filterByCategory: "શ્રેણી દ્વારા ફિલ્ટર કરો",
    allCategories: "તમામ શ્રેણીઓ",
    sorting: "દ્વારા સૉર્ટ કરો",
    sortName: "પાક નામ (A-Z)",
    sortCategory: "શ્રેણી",
    information: "માહિતી",
    duration: "સમયાવધિ",
    lightSpectrum: "પ્રકાશ સ્પેક્ટ્રમ",
    affectedRegions: "પ્રભાવિત પ્રદેશો",
    stats: "આંકડાશાસ્ત્ર",
    totalCrops: "કુલ પાકો",
    categories: "શ્રેણીઓ",
    regions: "પ્રદેશો",
    viewDetails: "વિવરણ જુઓ",
    quickInfo: "ઝડપી માહિતી",
    cropsCovered: "પાકો આવૃત્તા",
    panIndia: "સમગ્ર ભારતમાં કવરેજ",
    researchBacked: "સંશોધન-સમર્થિત ડેટા",
    optimization: "વાસ્તવિક સમય ઑપ્ટિમાઇઝેશન",
    features: "વૈશિષ્ટ્યો",
    multiLanguage: "બહુ-ભાષા સમર્થન",
    advancedFilter: "અદ્યતન ફિલ્ટરિંગ",
    categoriesSearch: "શ્રેણી-આધારિત શોધ",
    expandDetails: "વિસ્તૃત વિવરણ",
    privacy: "ગોપનીયતા નીતિ",
    terms: "સેવાની શરતો",
    contact: "અમને સંપર્ક કરો",
    madeWith: "ભારતીય ખેડૂતો માટે ❤️ સાથે બનાવવામાં આવ્યું",
    productsTitle: "CropShield ઉત્પાદનો",
    productsSubtitle: "અમારા સૌર-સંચાલિત પાક સુરક્ષા ઉપકરણો અને એસેસરીઝ જુઓ",
    hideDetails: "વિગતો છુપાવો",
    cropSingular: "પાક",
    cropPlural: "પાકો",
    showingPrefix: "બતાવી રહ્યા છીએ",
    inCategory: "શ્રેણીમાં",
    matchingSearch: "સાથે મેળ ખાતા",
    catNames: {
      FIBRE: "રેસા", FLOWER: "ફૂલ", FRUIT: "ફળ", GRAIN: "અનાજ", MEDICINAL: "ઔષધીય",
      OILSEED: "તેલીબિયાં", PLANTATION: "વાવેતર", PULSE: "કઠોળ", SPICE: "મસાલા", VEGETABLE: "શાકભાજી",
    },
  },
};
